var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC99-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-48.000000, -335.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/File-Signature/Filled",
    transform: "translate(48.000000, 335.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21161149,18.5679687 C9.09381687,18.3367188 8.8885747,18.3132813 8.80551951,18.3132813 C8.72246431,18.3132813 8.51722215,18.3363281 8.40541708,18.5550781 L8.09915105,19.1542969 C7.84479451,19.6535156 7.09969358,19.5984375 6.92200338,19.0726563 L6.24997504,17.1011719 L5.82631369,18.3464844 C5.59112374,19.0363281 4.93267173,19.5 4.18916802,19.5 L3.69443058,19.5 C3.341446,19.5 3.05554446,19.2203125 3.05554446,18.875 C3.05554446,18.5296875 3.341446,18.25 3.69443058,18.25 L4.18916802,18.25 C4.38203176,18.25 4.5529338,18.1296875 4.61402728,17.9507813 L5.34036094,15.8164063 C5.4721312,15.4332031 5.83709489,15.1753906 6.24997504,15.1753906 C6.6628552,15.1753906 7.02781889,15.4328125 7.15918985,15.8164063 L7.71342355,17.4429688 C8.5020486,16.8105469 9.87206002,17.0640625 10.3488288,17.9960938 C10.4242972,18.14375 10.5680466,18.2285156 10.7225772,18.240625 L10.7225772,15.0328125 L15.8336661,10.0683594 L15.8336661,8.25 L10.4027348,8.25 C9.87565375,8.25 9.44440562,7.828125 9.44440562,7.3125 L9.44440562,2 L1.45832917,2 C0.92725509,2 0.5,2.41796875 0.5,2.9375 L0.5,21.0625 C0.5,21.5820313 0.92725509,22 1.45832917,22 L14.8749376,22 C15.4060117,22 15.8332668,21.5820313 15.8332668,21.0625 L15.8332668,19.5 L10.7221779,19.4957031 C10.0785001,19.4835938 9.50110677,19.1332031 9.21161149,18.5679687 Z M15.8332668,6.76171875 C15.8332668,6.515625 15.7334408,6.27734375 15.5537541,6.1015625 L11.6445697,2.2734375 C11.464883,2.09765625 11.2213076,2 10.9657532,2 L10.7221779,2 L10.7221779,7 L15.8332668,7 L15.8332668,6.76171875 Z M11.9999501,15.553125 L11.9999501,18.25 L14.7547472,18.25 L21.2106914,11.8914062 L18.500217,9.23984375 L11.9999501,15.553125 L11.9999501,15.553125 Z M23.2020195,8.53632813 L21.9294382,7.29140625 C21.5325302,6.903125 20.8884532,6.903125 20.4915452,7.29140625 L19.4034423,8.35585938 L22.1139166,11.0074219 L23.2020195,9.94296875 C23.5993268,9.5546875 23.5993268,8.92460938 23.2020195,8.53632813 Z",
    id: "Icon",
    fill: "#586179"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileEdit);
export default __webpack_public_path__ + "static/media/file-edit.5728409c.svg";
export { ForwardRef as ReactComponent };